import script from "./FeaturedSection.vue?vue&type=script&setup=true&lang=js"
export * from "./FeaturedSection.vue?vue&type=script&setup=true&lang=js"

import "./FeaturedSection.vue?vue&type=style&index=0&id=48c0e9fe&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48c0e9fe"]])

export default __exports__